export default "__VITE_ASSET__453f43f1__"